import { Search, User } from '../models';

export enum CardTitleType {
    Online,
    Regular,
    Newest,
    Popular,
    GalleryPhotos,
}

const baseUrl = 'https://pazintys.draugas.lt'

export const cardTitleUrl = (type: CardTitleType, search: Search) => {
    const ageFrom = `&amzius=${search.ageFrom}`;
    const ageTo = `&amzius2=${search.ageTo}`;
    const gender = search.genderFemale && !search.genderMale ? '&lytis=1' : !search.genderFemale && search.genderMale ? '&lytis=2' : '';
    const location = search.location.id !== null
        ? `&vietove=${search.location.id}&vietovep=${search.location.display64}` : '';

    switch (type) {
        case CardTitleType.Popular:
            return `${baseUrl}/tgrupe.cfm?${ageFrom}${ageTo}${gender}${location}`;
        case CardTitleType.Newest:
            return `${baseUrl}/nagrupe.cfm?${ageFrom}${ageTo}${gender}${location}`;
        case CardTitleType.Online:
            return `${baseUrl}/pngrupe.cfm?${ageFrom}${ageTo}${gender}${location}`;
        case CardTitleType.Regular:
        default:
            return `${baseUrl}/ngrupe.cfm?${ageFrom}${ageTo}${gender}${location}`;
    }
}

export const cardTitle = (type: CardTitleType, search: Search, currentUser?: User) => {
    const genderAll = (search.genderFemale && search.genderMale) || (search.genderFemale === false && search.genderMale === false);
    const genderFemale = genderAll === false && search.genderFemale;

    const ageAndLocation = search.location.id !== ''
        ? `(${search.ageFrom}-${search.ageTo} m., ${search.location.display})`
        : `${search.ageFrom}-${search.ageTo} m.`;

    switch (type) {
        case CardTitleType.Newest:
            if (genderAll) {
                return `Naujausi ${ageAndLocation}`;
            } else {
                return genderFemale ? `Naujausios ${ageAndLocation}` : `Naujausi ${ageAndLocation}`;
            }
        case CardTitleType.Online:
            if (genderAll) {
                return `Prisijungę ${ageAndLocation}`;
            } else {
                return genderFemale ? `Prisijungusios ${ageAndLocation}` : `Prisijungę ${ageAndLocation}`;
            }
        case CardTitleType.Popular:
            if (genderAll) {
                return `Populiariausi ${ageAndLocation}`;
            } else {
                return genderFemale ? `Populiariausios ${ageAndLocation}` : `Populiariausi ${ageAndLocation}`;
            }
        case CardTitleType.GalleryPhotos:
            if (typeof currentUser === 'undefined' || currentUser === null || currentUser.gender == 2) {
                return 'Mėgstamiausios merginų nuotraukos';
            } else {
                return 'Mėgstamiausios vaikinų nuotraukos';
            }
        case CardTitleType.Regular:
        default:
            return `${genderAll ? 'Nariai' : genderFemale ? 'Merginos' : 'Vaikinai'} ${ageAndLocation}`;
    }
};
